// extracted by mini-css-extract-plugin
module.exports = {"label":"Label_label__nZypd","number":"Label_number___G6qx"};